import { COLOR_TOKENS } from "~/designSystem/constants/token";

const BROWN_TAG_COLORS = {
  default: {
    backgroundColor: COLOR_TOKENS.brown.a3,
    borderColor: COLOR_TOKENS.brown.a3,
    textColor: COLOR_TOKENS.brown.a11,
    iconColor: COLOR_TOKENS.brown.a12,
  },
  hover: {
    backgroundColor: COLOR_TOKENS.brown.a4,
    borderColor: COLOR_TOKENS.brown.a3,
    textColor: COLOR_TOKENS.brown.a12,
    iconColor: COLOR_TOKENS.brown.a12,
  },
  focus: {
    backgroundColor: COLOR_TOKENS.brown.a3,
    borderColor: COLOR_TOKENS.brown.a8,
    textColor: COLOR_TOKENS.brown.a12,
    boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.brown.a3}`,
    iconColor: COLOR_TOKENS.brown.a12,
  },
  disabled: {
    backgroundColor: COLOR_TOKENS.brown.a3,
    borderColor: COLOR_TOKENS.brown.a3,
    textColor: COLOR_TOKENS.brown.a7,
    iconColor: COLOR_TOKENS.brown.a8,
  },
};

const GRASS_TAG_COLORS = {
  default: {
    backgroundColor: COLOR_TOKENS.status.success.a3,
    borderColor: COLOR_TOKENS.status.success.a3,
    textColor: COLOR_TOKENS.status.success.a11,
    iconColor: COLOR_TOKENS.status.success.a12,
  },
  hover: {
    backgroundColor: COLOR_TOKENS.status.success.a4,
    borderColor: COLOR_TOKENS.status.success.a3,
    textColor: COLOR_TOKENS.status.success.a12,
    iconColor: COLOR_TOKENS.status.success.a12,
  },
  focus: {
    backgroundColor: COLOR_TOKENS.status.success.a3,
    borderColor: COLOR_TOKENS.status.success.a8,
    textColor: COLOR_TOKENS.status.success.a12,
    boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.status.success.a3}`,
    iconColor: COLOR_TOKENS.status.success.a12,
  },
  disabled: {
    backgroundColor: COLOR_TOKENS.status.success.a3,
    borderColor: COLOR_TOKENS.status.success.a3,
    textColor: COLOR_TOKENS.status.success.a7,
    iconColor: COLOR_TOKENS.status.success.a8,
  },
};

const IRIS_TAG_COLORS = {
  default: {
    backgroundColor: COLOR_TOKENS.status.feature.a3,
    borderColor: COLOR_TOKENS.status.feature.a3,
    textColor: COLOR_TOKENS.status.feature.a11,
    iconColor: COLOR_TOKENS.status.feature.a12,
  },
  hover: {
    backgroundColor: COLOR_TOKENS.status.feature.a4,
    borderColor: COLOR_TOKENS.status.feature.a3,
    textColor: COLOR_TOKENS.status.feature.a12,
    iconColor: COLOR_TOKENS.status.feature.a12,
  },
  focus: {
    backgroundColor: COLOR_TOKENS.status.feature.a3,
    borderColor: COLOR_TOKENS.status.feature.a8,
    textColor: COLOR_TOKENS.status.feature.a12,
    boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.status.feature.a3}`,
    iconColor: COLOR_TOKENS.status.feature.a12,
  },
  disabled: {
    backgroundColor: COLOR_TOKENS.status.feature.a3,
    borderColor: COLOR_TOKENS.status.feature.a3,
    textColor: COLOR_TOKENS.status.feature.a7,
    iconColor: COLOR_TOKENS.status.feature.a8,
  },
};

export const TAG_COLORS_MAP = {
  blue: {
    default: {
      backgroundColor: COLOR_TOKENS.core.blue.a3,
      borderColor: COLOR_TOKENS.core.blue.a3,
      textColor: COLOR_TOKENS.core.blue.a11,
      iconColor: COLOR_TOKENS.core.blue.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.core.blue.a4,
      borderColor: COLOR_TOKENS.core.blue.a3,
      textColor: COLOR_TOKENS.core.blue.a12,
      iconColor: COLOR_TOKENS.core.blue.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.core.blue.a3,
      borderColor: COLOR_TOKENS.core.blue.a8,
      textColor: COLOR_TOKENS.core.blue.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.core.blue.a3}`,
      iconColor: COLOR_TOKENS.core.blue.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.core.blue.a3,
      borderColor: COLOR_TOKENS.core.blue.a3,
      textColor: COLOR_TOKENS.core.blue.a7,
      iconColor: COLOR_TOKENS.core.blue.a8,
    },
  },
  grass: GRASS_TAG_COLORS,
  orange: {
    default: {
      backgroundColor: COLOR_TOKENS.status.warning.a3,
      borderColor: COLOR_TOKENS.status.warning.a3,
      textColor: COLOR_TOKENS.status.warning.a11,
      iconColor: COLOR_TOKENS.status.warning.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.status.warning.a4,
      borderColor: COLOR_TOKENS.status.warning.a3,
      textColor: COLOR_TOKENS.status.warning.a12,
      iconColor: COLOR_TOKENS.status.warning.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.status.warning.a3,
      borderColor: COLOR_TOKENS.status.warning.a8,
      textColor: COLOR_TOKENS.status.warning.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.status.warning.a3}`,
      iconColor: COLOR_TOKENS.status.warning.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.status.warning.a3,
      borderColor: COLOR_TOKENS.status.warning.a3,
      textColor: COLOR_TOKENS.status.warning.a7,
      iconColor: COLOR_TOKENS.status.warning.a8,
    },
  },
  red: {
    default: {
      backgroundColor: COLOR_TOKENS.status.error.a3,
      borderColor: COLOR_TOKENS.status.error.a3,
      textColor: COLOR_TOKENS.status.error.a11,
      iconColor: COLOR_TOKENS.status.error.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.status.error.a4,
      borderColor: COLOR_TOKENS.status.error.a3,
      textColor: COLOR_TOKENS.status.error.a12,
      iconColor: COLOR_TOKENS.status.error.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.status.error.a3,
      borderColor: COLOR_TOKENS.status.error.a8,
      textColor: COLOR_TOKENS.status.error.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.status.error.a3}`,
      iconColor: COLOR_TOKENS.status.error.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.status.error.a3,
      borderColor: COLOR_TOKENS.status.error.a3,
      textColor: COLOR_TOKENS.status.error.a7,
      iconColor: COLOR_TOKENS.status.error.a8,
    },
  },
  iris: IRIS_TAG_COLORS,
  sky: {
    default: {
      backgroundColor: COLOR_TOKENS.status.info.a3,
      borderColor: COLOR_TOKENS.status.info.a3,
      textColor: COLOR_TOKENS.status.info.a11,
      iconColor: COLOR_TOKENS.status.info.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.status.info.a4,
      borderColor: COLOR_TOKENS.status.info.a3,
      textColor: COLOR_TOKENS.status.info.a12,
      iconColor: COLOR_TOKENS.status.info.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.status.info.a3,
      borderColor: COLOR_TOKENS.status.info.a8,
      textColor: COLOR_TOKENS.status.info.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.status.info.a3}`,
      iconColor: COLOR_TOKENS.status.info.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.status.info.a3,
      borderColor: COLOR_TOKENS.status.info.a3,
      textColor: COLOR_TOKENS.status.info.a7,
      iconColor: COLOR_TOKENS.status.info.a8,
    },
  },
  pink: {
    default: {
      backgroundColor: COLOR_TOKENS.pink.a3,
      borderColor: COLOR_TOKENS.pink.a3,
      textColor: COLOR_TOKENS.pink.a11,
      iconColor: COLOR_TOKENS.pink.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.pink.a4,
      borderColor: COLOR_TOKENS.pink.a3,
      textColor: COLOR_TOKENS.pink.a12,
      iconColor: COLOR_TOKENS.pink.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.pink.a3,
      borderColor: COLOR_TOKENS.pink.a8,
      textColor: COLOR_TOKENS.pink.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.pink.a3}`,
      iconColor: COLOR_TOKENS.pink.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.pink.a3,
      borderColor: COLOR_TOKENS.pink.a3,
      textColor: COLOR_TOKENS.pink.a7,
      iconColor: COLOR_TOKENS.pink.a8,
    },
  },
  plum: {
    default: {
      backgroundColor: COLOR_TOKENS.plum.a3,
      borderColor: COLOR_TOKENS.plum.a3,
      textColor: COLOR_TOKENS.plum.a11,
      iconColor: COLOR_TOKENS.plum.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.plum.a4,
      borderColor: COLOR_TOKENS.plum.a3,
      textColor: COLOR_TOKENS.plum.a12,
      iconColor: COLOR_TOKENS.plum.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.plum.a3,
      borderColor: COLOR_TOKENS.plum.a8,
      textColor: COLOR_TOKENS.plum.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.plum.a3}`,
      iconColor: COLOR_TOKENS.plum.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.plum.a3,
      borderColor: COLOR_TOKENS.plum.a3,
      textColor: COLOR_TOKENS.plum.a7,
      iconColor: COLOR_TOKENS.plum.a8,
    },
  },
  lime: {
    default: {
      backgroundColor: COLOR_TOKENS.lime.a3,
      borderColor: COLOR_TOKENS.lime.a3,
      textColor: COLOR_TOKENS.lime.a11,
      iconColor: COLOR_TOKENS.lime.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.lime.a4,
      borderColor: COLOR_TOKENS.lime.a3,
      textColor: COLOR_TOKENS.lime.a12,
      iconColor: COLOR_TOKENS.lime.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.lime.a3,
      borderColor: COLOR_TOKENS.lime.a8,
      textColor: COLOR_TOKENS.lime.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.lime.a3}`,
      iconColor: COLOR_TOKENS.lime.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.lime.a3,
      borderColor: COLOR_TOKENS.lime.a3,
      textColor: COLOR_TOKENS.lime.a7,
      iconColor: COLOR_TOKENS.lime.a8,
    },
  },
  jade: {
    default: {
      backgroundColor: COLOR_TOKENS.jade.a3,
      borderColor: COLOR_TOKENS.jade.a3,
      textColor: COLOR_TOKENS.jade.a11,
      iconColor: COLOR_TOKENS.jade.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.jade.a4,
      borderColor: COLOR_TOKENS.jade.a3,
      textColor: COLOR_TOKENS.jade.a12,
      iconColor: COLOR_TOKENS.jade.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.jade.a3,
      borderColor: COLOR_TOKENS.jade.a8,
      textColor: COLOR_TOKENS.jade.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.jade.a3}`,
      iconColor: COLOR_TOKENS.jade.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.jade.a3,
      borderColor: COLOR_TOKENS.jade.a3,
      textColor: COLOR_TOKENS.jade.a7,
      iconColor: COLOR_TOKENS.jade.a8,
    },
  },
  amber: {
    default: {
      backgroundColor: COLOR_TOKENS.amber.a3,
      borderColor: COLOR_TOKENS.amber.a3,
      textColor: COLOR_TOKENS.amber.a11,
      iconColor: COLOR_TOKENS.amber.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.amber.a4,
      borderColor: COLOR_TOKENS.amber.a3,
      textColor: COLOR_TOKENS.amber.a12,
      iconColor: COLOR_TOKENS.amber.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.amber.a3,
      borderColor: COLOR_TOKENS.amber.a8,
      textColor: COLOR_TOKENS.amber.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.amber.a3}`,
      iconColor: COLOR_TOKENS.amber.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.amber.a3,
      borderColor: COLOR_TOKENS.amber.a3,
      textColor: COLOR_TOKENS.amber.a7,
      iconColor: COLOR_TOKENS.amber.a8,
    },
  },
  brown: BROWN_TAG_COLORS,
  indigo: {
    default: {
      backgroundColor: COLOR_TOKENS.indigo.a3,
      borderColor: COLOR_TOKENS.indigo.a3,
      textColor: COLOR_TOKENS.indigo.a11,
      iconColor: COLOR_TOKENS.indigo.a12,
    },
    hover: {
      backgroundColor: COLOR_TOKENS.indigo.a4,
      borderColor: COLOR_TOKENS.indigo.a3,
      textColor: COLOR_TOKENS.indigo.a12,
      iconColor: COLOR_TOKENS.indigo.a12,
    },
    focus: {
      backgroundColor: COLOR_TOKENS.indigo.a3,
      borderColor: COLOR_TOKENS.indigo.a8,
      textColor: COLOR_TOKENS.indigo.a12,
      boxShadow: `0px 0px 0px 4px ${COLOR_TOKENS.indigo.a3}`,
      iconColor: COLOR_TOKENS.indigo.a12,
    },
    disabled: {
      backgroundColor: COLOR_TOKENS.indigo.a3,
      borderColor: COLOR_TOKENS.indigo.a3,
      textColor: COLOR_TOKENS.indigo.a7,
      iconColor: COLOR_TOKENS.indigo.a8,
    },
  },
  // Below are the colors that are the old colors
  slate: BROWN_TAG_COLORS,
  green: GRASS_TAG_COLORS,
  violet: IRIS_TAG_COLORS,
};
